/**
 * Design System Getproof - Button Styles
 * Styles basés sur l'analyse du code existant
 */

import { ButtonVariantStyles } from './Button.types';

export const buttonStyles: ButtonVariantStyles = {
  // Classes de base communes à tous les boutons
  base: [
    // Layout & Display
    'inline-flex items-center justify-center gap-2',
    
    // Typography (Bricolage Grotesque comme dans le code)
    'font-["Bricolage_Grotesque"] font-semibold',
    
    // Interactions
    'cursor-pointer transition-all duration-200',
    'focus:outline-none focus:ring-2 focus:ring-offset-2',
    'disabled:pointer-events-none disabled:opacity-50',
    
    // Border radius (basé sur rounded-lg du code)
    'rounded-lg',
    
    // Prevent text selection
    'select-none',
  ].join(' '),

  variants: {
    // Bouton principal (turquoise Getproof)
    primary: [
      'bg-[#40E0D0] text-white',
      'hover:bg-[#36C7B8]',
      'focus:ring-[#40E0D0]/20',
      'active:bg-[#2DB5A5]',
      'shadow-sm hover:shadow-md',
    ].join(' '),

    // Bouton secondaire (outline avec turquoise)
    secondary: [
      'bg-white text-[#40E0D0] border border-[#40E0D0]',
      'hover:bg-[#40E0D0]/5',
      'focus:ring-[#40E0D0]/20',
      'active:bg-[#40E0D0]/10',
    ].join(' '),

    // Bouton outline (gris comme dans le code)
    outline: [
      'bg-white text-neutral-600 border border-neutral-300',
      'hover:bg-neutral-50 hover:text-neutral-700',
      'focus:ring-neutral-200',
      'active:bg-neutral-100',
    ].join(' '),

    // Bouton ghost (transparent)
    ghost: [
      'bg-transparent text-neutral-600',
      'hover:bg-neutral-100 hover:text-neutral-700',
      'focus:ring-neutral-200',
      'active:bg-neutral-200',
    ].join(' '),

    // Bouton destructif (rouge)
    destructive: [
      'bg-red-500 text-white',
      'hover:bg-red-600',
      'focus:ring-red-200',
      'active:bg-red-700',
      'shadow-sm hover:shadow-md',
    ].join(' '),
  },

  sizes: {
    // Petit bouton (12px comme dans le code)
    sm: [
      'h-8 px-3 text-xs',
      'gap-1',
    ].join(' '),

    // Bouton moyen (standard, 14px comme dans le code)
    md: [
      'h-10 px-4 text-sm',
      'gap-2',
    ].join(' '),

    // Grand bouton
    lg: [
      'h-12 px-6 text-base',
      'gap-2',
    ].join(' '),

    // Bouton icône seulement
    icon: [
      'h-10 w-10 p-0',
      'gap-0',
    ].join(' '),
  },
};

// Classes pour les états de chargement
export const loadingStyles = {
  spinner: [
    'animate-spin rounded-full border-2 border-transparent',
    'border-t-current border-r-current',
  ].join(' '),
  
  spinnerSizes: {
    sm: 'h-3 w-3',
    md: 'h-4 w-4', 
    lg: 'h-5 w-5',
    icon: 'h-4 w-4',
  },
};

// Classes pour la largeur complète
export const fullWidthStyles = 'w-full';

// Classes pour les icônes
export const iconStyles = {
  left: 'mr-1',
  right: 'ml-1',
  only: '',
};